import AnimatedSection from "@/components/AnimatedSection";
import { Sparkles, Target, Eye } from "lucide-react";

const AboutUs = () => {
  return (
    <main className="pt-16">

      <section className="bg-gradient-to-b from-white via-gray-100 to-gray-200 py-28">
        <div className="container mx-auto px-4">

          {/* ===========================
              TITULO PRINCIPAL
          ============================ */}
          <AnimatedSection className="mb-20">
            <h1 className="text-6xl font-extrabold text-gray-900 leading-tight text-center md:text-left">
              Conoce más sobre{" "}
              <span className="text-[#f4a320]">SERGEN</span>
            </h1>

            <p className="mt-6 text-xl text-gray-700 max-w-3xl text-center md:text-left">
              Ingeniería, tecnología y eficiencia energética unidas para transformar
              la operación de las PYMEs industriales del Perú.
            </p>
          </AnimatedSection>

          {/* ===========================
              3 CARDS UNA AL COSTADO DE LA OTRA
          ============================ */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-16">

            {/* QUIENES SOMOS */}
            <AnimatedSection>
              <div className="relative p-10 rounded-3xl overflow-hidden shadow-2xl
                              bg-white/20 backdrop-blur-2xl border border-white/30 hover:bg-white/30 transition-all duration-300">
                
                <div className="absolute inset-0 bg-gradient-to-br from-white/50 to-transparent opacity-40"></div>

                <div className="relative z-10">
                  <div className="flex items-center gap-3 mb-4">
                    <Sparkles className="w-8 h-8 text-[#f4a320]" />
                    <h2 className="text-3xl font-extrabold text-gray-900">Quiénes Somos</h2>
                  </div>

                  <p className="text-gray-800 leading-relaxed text-justify">
                    SERGEN es un startup tecnológico especializado en eficiencia energética,
                    orientado a brindar soluciones inteligentes para optimizar el consumo eléctrico
                    en pequeñas y medianas empresas industriales.
                  </p>
                </div>
              </div>
            </AnimatedSection>

            {/* MISIÓN */}
            <AnimatedSection>
              <div className="relative p-10 rounded-3xl overflow-hidden shadow-2xl
                              bg-white/20 backdrop-blur-2xl border border-white/30 hover:bg-white/30 transition-all duration-300">

                <div className="absolute inset-0 bg-gradient-to-br from-white/50 to-transparent opacity-40"></div>

                <div className="relative z-10">
                  <div className="flex items-center gap-3 mb-4">
                    <Target className="w-8 h-8 text-[#f4a320]" />
                    <h2 className="text-3xl font-extrabold text-gray-900">Misión</h2>
                  </div>

                  <p className="text-gray-800 leading-relaxed text-justify">
                    Impulsar a las PYMEs industriales hacia un modelo energético eficiente,
                    seguro y sostenible mediante soluciones tecnológicas inteligentes que reduzcan
                    costos y mejoren la operación diaria.
                  </p>
                </div>
              </div>
            </AnimatedSection>

            {/* VISIÓN */}
            <AnimatedSection>
              <div className="relative p-10 rounded-3xl overflow-hidden shadow-2xl
                              bg-white/20 backdrop-blur-2xl border border-white/30 hover:bg-white/30 transition-all duration-300">

                <div className="absolute inset-0 bg-gradient-to-br from-white/50 to-transparent opacity-40"></div>

                <div className="relative z-10">
                  <div className="flex items-center gap-3 mb-4">
                    <Eye className="w-8 h-8 text-[#f4a320]" />
                    <h2 className="text-3xl font-extrabold text-gray-900">Visión</h2>
                  </div>

                  <p className="text-gray-800 leading-relaxed text-justify">
                    Ser el startup líder en eficiencia eléctrica y tecnología energética en el Perú para 2030,
                    reconocido por su innovación, impacto industrial y compromiso con el uso responsable de la energía.
                  </p>
                </div>
              </div>
            </AnimatedSection>

          </div>

          {/* ===========================
              VALORES — IMAGEN
          ============================ */}
          <AnimatedSection className="mt-28">
            <h2 className="text-5xl font-extrabold text-gray-900 mb-10 text-left">
              Valores
            </h2>

            <img
              src="/lovable-uploads/wpsergen.png"
              className="w-full max-w-7xl mx-auto drop-shadow-2xl"
              alt="Valores SERGEN"
            />
          </AnimatedSection>

        </div>
      </section>
    </main>
  );
};

export default AboutUs;
